import { defineStore } from "pinia";
import { computed, ref } from "vue";

export const useMenuAccessStore = defineStore("menuAccess", () => {
  const accessMenu = ref("");
  const getAccessMenu = computed(() => accessMenu);
  function setAccessMenu(val) {
    this.accessMenu = val;
  }

  return { accessMenu, getAccessMenu, setAccessMenu };
});
